import { useDispatch, useSelector } from 'react-redux';
import { Box, Dropdown } from '@quintoandar-tokko/jopijs';
import { setMiniCards } from '@/store/slices/components/dashboard/DashboardSlice';
import Trans from '@/components/shared/Trans';
import translations from '../Dashboard.trans.json';
import styles from './dashboardMiniCards.module.scss';

export default function StatusDropdown() {
  const dispatch = useDispatch();
  const { miniCards } = useSelector((state) => state.DashboardSlice);

  const dropdownOptions = [
    { id: 1, value: Trans(translations, 'Appraisal') },
    { id: 2, value: Trans(translations, 'Available') },
    { id: 3, value: Trans(translations, 'Reserved') },
  ];

  const selectedOption = dropdownOptions.find(
    (option) => option.id === miniCards.selectedStatusId
  );

  const handleClickDropdownOption = (selectedId) => {
    const key = 'selectedStatusId';
    const value = selectedId;
    dispatch(setMiniCards({ key, value }));
  };

  return (
    <Box onClick={(event) => event.stopPropagation()}>
      <Dropdown className={styles.dd}>
        <Dropdown.Button
          variant="dropdownTransparent"
          text={selectedOption.value}
          className={styles.ddButton}
        />
        <Dropdown.Items className={styles.ddItems} clickClose>
          {dropdownOptions.map((option) => (
            <Dropdown.Default
              key={option.id}
              onClick={() => handleClickDropdownOption(option.id)}
            >
              {option.value}
            </Dropdown.Default>
          ))}
        </Dropdown.Items>
      </Dropdown>
    </Box>
  );
}
